export const CustomSpinner = () => (
  <span className="indicator-progress d-flex flex-center" style={{ whiteSpace: 'nowrap' }}>
    Please wait...
    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
  </span>
);
